<template>
    <div class="step-box">
        <div class="step-head">投稿管理</div>
        <div class="step-body">
            <div class="section-tip">
                <p>1. 投稿时间截止前，可点击“编辑作品”进行作品修改。</p>
                <p>2. 成绩公示前，请勿删除作品 或 取消作品发布。</p>
                <p>3. 如需修改个人信息或作品海报，可以取消投稿后重新投稿。</p>
            </div>
            <div class="work">
                <img class="poster" :src="myPostInfo.coverUrl">
                <div class="title">{{myPostInfo.title}}</div>
            </div>
            <div class="op-box">
                <a href="javascript:" class="btn secondary" @click="cancelPost">取消投稿</a>
                <a :href="editUrl" class="btn primary" target="_blank">编辑作品</a>
            </div>
        </div>
        <Modal :show-modal="showModal" :msg="msg" :need-cancel="true" @confirmModal="confirmModal" @cancelModal="cancelModal"></Modal>
    </div>
</template>

<script>
    import Modal from '../../components/modal'
    export default {
        name: "success",
        props: {
          myPostInfo: Object
        },
        components: {
            Modal
        },
        data() {
            return {
                showModal: false,
                msg: '取消投稿后，投稿信息将被删除，确定是否取消投稿？',
                cancelProjectId: 0,
                editUrl: `${process.env.VUE_APP_EDIT_URL}${this.myPostInfo.projectId}`,
            }
        },
        methods: {
            cancelPost() {
                this.showModal = true
            },
            confirmModal() {
                this.showModal = false
                this.$emit('cancelPost', this.myPostInfo.projectId)
            },
            cancelModal() {
                this.showModal = false
            }
        }
    }
</script>

<style lang="scss" scoped>
    .work {
        width: 286px;
        margin: 0 auto 50px;
        background: rgba(2, 27, 63, .7);
        padding: 8px 0;
        border-radius: 10px;
        text-align: center;
        cursor: pointer;

        .poster {
            width: 271px;
            height: 204px;
            border-radius: 10px;
            margin-bottom: 8px;
        }

        .title {
            width: 271px;
            height: 24px;
            line-height: 24px;
            font-size: 16px;
            color: #fff;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin: 0 auto 5px;
            text-align: left;
        }
    }
</style>
